/**
 * ImageMetadata 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ImageMetadata
 */
export interface ImageMetadata {
  /** 色彩空间(sRGB/CMYK) */
  color_space?: string
  /** 位深度(8/16) */
  bit_depth?: number
  /** 是否有透明通道 */
  has_alpha?: boolean
  /** 分辨率DPI */
  dpi?: number
  /** EXIF方向(1-8) */
  exif_orientation?: number
}

/**
 * ImageMetadata Schema
 */
export const ImageMetadataSchema: SchemaDefinition = {
  properties: {
    color_space: {
      description: '色彩空间(sRGB/CMYK)',
      format: '*string',
      type: 'string',
      label: '色彩空间',
    },
    bit_depth: {
      description: '位深度(8/16)',
      format: '*int',
      type: 'integer',
      label: '位深度',
    },
    has_alpha: {
      description: '是否有透明通道',
      format: '*bool',
      type: 'boolean',
      label: '是否有透明通道',
    },
    dpi: {
      description: '分辨率DPI',
      format: '*int',
      type: 'integer',
      label: '分辨率DPI',
    },
    exif_orientation: {
      description: 'EXIF方向(1-8)',
      format: '*int',
      type: 'integer',
      label: 'EXIF方向',
    },
  },
  type: 'object',
}
